import { render, staticRenderFns } from "./FabButtonWhatsApp.vue?vue&type=template&id=72382fb9&"
import script from "./FabButtonWhatsApp.vue?vue&type=script&lang=js&"
export * from "./FabButtonWhatsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports